import { useEffect, useState } from 'react';
import { type Nullable } from '@libs/core';
import type { DiscountDetails, EligiblePromotion } from '@libs/common-types';
import sanitizeHtml from 'sanitize-html';
import { Icon } from '@petsmart-ui/sparky';
import type { ProductPromotion } from '@libs/common-next';
import apiProxyClient from '@libs/api-proxy-client';
import OfferDetails from './OfferDrawer';

type PromoItemProps = {
    readonly promotion: ProductPromotion | EligiblePromotion;
    readonly isCTEnabled: boolean;
};

export default function PromoItem({ promotion, isCTEnabled }: PromoItemProps) {
    const [algoliaDiscountDetails, setAlgoliaDiscountDetails] =
        useState<Nullable<DiscountDetails>>(null);

    useEffect(() => {
        const fetchCTPromotions = async () => {
            const discountDetails =
                await apiProxyClient.discounts.getDiscountDetails(
                    (promotion as EligiblePromotion)?.promoKey as string
                );

            setAlgoliaDiscountDetails(discountDetails);
        };

        if (isCTEnabled) {
            fetchCTPromotions();
        }
    }, [isCTEnabled, promotion]);

    if (isCTEnabled) {
        return (
            <div
                className="product-promotions-item"
                data-testid="product-promotions-item"
                key={(promotion as EligiblePromotion).promoKey}
            >
                <div className="product-promotions-item-callout">
                    <Icon name="tag" data-testid="promo-icon" />
                    {(promotion as EligiblePromotion)?.promoText}
                </div>
                {(algoliaDiscountDetails as DiscountDetails)
                    ?.termsAndConditions && (
                    <OfferDetails
                        details={sanitizeHtml(
                            (algoliaDiscountDetails as DiscountDetails)
                                .termsAndConditions,
                            {
                                allowedTags: [],
                                allowedAttributes: {},
                            }
                        )}
                        promoMsg={(promotion as EligiblePromotion)?.promoText}
                    />
                )}
            </div>
        );
    }

    return (
        <div
            className="product-promotions-item"
            key={(promotion as ProductPromotion).promotion_id}
        >
            <div className="product-promotions-item-callout">
                <Icon name="tag" data-testid="promo-icon" />
                {(promotion as ProductPromotion).callout_msg}
            </div>
            {(promotion as ProductPromotion).details && (
                <OfferDetails
                    details={sanitizeHtml(
                        (promotion as ProductPromotion).details as string,
                        {
                            allowedTags: [],
                            allowedAttributes: {},
                        }
                    )}
                    promoMsg={(promotion as ProductPromotion).callout_msg}
                />
            )}
        </div>
    );
}
